export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_yard-sale-finder-4/artifacts/wh302h2p_image_66c0b47d.jpg";

export const PLANS = {
  buyer: [
    { key: "buyer_weekly", name: "Weekly Shopper Pass", price: 5, unit: "week", sub: false,
      perks: ["Browse all current sales", "Map + GPS 'Sales Near Me'", "Route planner", "7am–10pm access"] },
    { key: "buyer_monthly", name: "Monthly Unlimited", price: 10, unit: "month", sub: true,
      perks: ["Everything in Weekly", "Unlimited browsing all month", "Auto-renews on the 1st", "Cancel anytime"] },
  ],
  seller: [
    { key: "seller_weekly", name: "Standard Seller", price: 5, unit: "week", sub: false,
      perks: ["1 listing for up to a week", "Up to 5 photos", "Address pin on map", "Shopper ratings"] },
    { key: "seller_pro_monthly", name: "Pro Seller", price: 25, unit: "month", sub: true,
      perks: ["Unlimited listings for a month", "Full shopper browsing included", "Auto-renews on the 1st", "Cancel anytime"] },
  ],
  addons: [
    { key: "highlight_weekly", name: "Highlight my goodies (Week)", price: 5, unit: "week", sub: false,
      perks: ["Brighter glowing gold map pin", "Top of the listings", "Stand out to shoppers"] },
    { key: "highlight_monthly", name: "Highlight my goodies (Month)", price: 20, unit: "month", sub: true,
      perks: ["Gold pin all month", "Top placement", "Recurring until you turn it off"] },
  ],
};

export function hasFreePass(user) {
  const fp = user?.free_pass;
  return !!(fp && fp.active && (!fp.expires || Date.parse(fp.expires) >= Date.now()));
}

export function canBrowse(user, promo) {
  if (promo && promo.active) return true;
  if (!user) return false;
  if (user.role === "admin" || (user.permissions && user.permissions.length)) return true;
  if (hasFreePass(user)) return true;
  const plan = user.plan || {};
  if (plan.type === "trial" && plan.trial_start && plan.trial_end) {
    const now = Date.now();
    if (now >= Date.parse(plan.trial_start) && now <= Date.parse(plan.trial_end)) return true;
  }
  return plan.status === "active" && (plan.browsing || ["buyer_weekly", "buyer_monthly", "seller_pro_monthly"].includes(plan.type));
}
